var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExpandNo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 5,
    height: 9,
    viewBox: "0 0 5 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 7.52997L3.05333 4.46997L0 1.40997L0.94 0.469971L4.94 4.46997L0.94 8.46997L0 7.52997Z",
    fill: "#303030"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpandNo);
export default __webpack_public_path__ + "static/media/expand-no.41627743bfd998104d8c93fffb24d32a.svg";
export { ForwardRef as ReactComponent };